import { normalizePhoneNumber } from "../../../../../utils/helpers/phonenumber/phonenumber";
import { getRingCentralUrl } from "../../../helpers/clients.helpers";
import { RingCentralDestination } from "../../../types/clients.types";

interface CommunicationPhoneLinkProps {
    value?: string | null;
    destination?: Extract<RingCentralDestination, "dialer" | "new-sms">;
}

export default function CommunicationPhoneLink({
    value,
    destination = "dialer",
}: CommunicationPhoneLinkProps) {
    if (!value) return <span>--</span>;

    const ringCentralUrl = getRingCentralUrl(value, destination);
    const displayValue = normalizePhoneNumber(value);

    if (!ringCentralUrl) return <span>{displayValue}</span>;

    const isNewSms = destination === "new-sms";

    return (
        <a
            href={ringCentralUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-textLink underline"
            aria-label={`${
                isNewSms ? "Text" : "Call"
            } ${displayValue} in RingCentral`}
            title={`Open RingCentral ${isNewSms ? "new message" : "dialer"}`}
            onClick={(event) => event.stopPropagation()}
        >
            {displayValue}
        </a>
    );
}
